const MAIN_FRAMES = {
  CONFIG_USER_ALERT: 'Config - User Alert',
  CONFIG_USER_ALERT_GROUP_WINDOW: 'Config - User Alert Group Setting Window',
  CONFIG_USER_ALERT_RULE_WINDOW: 'Config - User Alert Rule Setting Window',
  CONFIG_USER_ALERT_NOTIFICATION_WINDOW: 'Config - User Alert Notification Setting Window',

  CONFIG_SYSTEM_ALERT_INFRASTRUCTURE: 'Config - System Alert > Infrastructure',
  CONFIG_SYSTEM_ALERT_NETWORK_DEVICE: 'Config - System Alert > Network Device',
  CONFIG_SYSTEM_ALERT_KUBERNETES: 'Config - System Alert > Kubernetes',
  CONFIG_SYSTEM_ALERT_APPLICATION: 'Config - System Alert > Application',
  CONFIG_SYSTEM_ALERT_DATABASE: 'Config - System Alert > Database',
  CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE: 'Config - System Alert > Message Queue',
  CONFIG_SYSTEM_ALERT_WEB_SERVER: 'Config - System Alert > Web Server',
  CONFIG_SYSTEM_ALERT_CLOUD: 'Config - System Alert > Cloud',
  CONFIG_GROUP_NOTIFICATION_SETTING: 'Config - Group Notification Setting',
  CONFIG_INTERFACE_SETTING_WINDOW: 'Config - Interface Setting Window',

  CONFIG_EXTERNAL_ALERT: 'Config - External Alert',
  CONFIG_EXTERNAL_ALERT_WINDOW: 'Config - External Alert Setting Window',
  CONFIG_EXTERNAL_ALERT_GROUP_WINDOW: 'Config - External Alert Group Setting Window',

  CONFIG_NOTIFICATION: 'Config - Notification',
  CONFIG_NOTIFICATION_WINDOW: 'Config - Notification Setting Window',
} as const;

export const CONFIG_ALERT_FRAME_NAMES = {
  // 사용자 알람
  CONFIG_USER_ALERT: {
    ALERT_GROUP_LIST: `${MAIN_FRAMES.CONFIG_USER_ALERT}/Alert Group List`,
    ALERT_GROUP_DELETE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Delete] Alert Group`,
    RULE_LIST: `${MAIN_FRAMES.CONFIG_USER_ALERT}/Rule List`,
    RULE_DELETE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Delete] Rule`,
    RULE_ACTIVATE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Activate] Rule`,
    RULE_MUTE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[MUTE] Rule`,
    RULE_ISOLATED_SEND: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Isolated Sending] Rule`,
    RULE_DUPLICATE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Duplicate] Rule`,
    RULE_MOVE: `${MAIN_FRAMES.CONFIG_USER_ALERT}/[Move] Rule`,
    TAGS: `${MAIN_FRAMES.CONFIG_USER_ALERT}/Tags`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_USER_ALERT}/Alert Setting`,
  },
  CONFIG_USER_ALERT_GROUP_WINDOW: {
    ALERT_GROUP_SAVE: `${MAIN_FRAMES.CONFIG_USER_ALERT_GROUP_WINDOW}/[Save] Alert Group`,
    ALERT_GROUP_DELETE: `${MAIN_FRAMES.CONFIG_USER_ALERT_GROUP_WINDOW}/[Delete] Alert Group`,
  },
  CONFIG_USER_ALERT_RULE_WINDOW: {
    RULE_DATA: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Rule Data`,
    RULE_SAVE: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/[Save] Rule`,
    TREND: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Trend`,
    TABLE: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Table`,
    NOTIFICATION: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Notification`,
    USER_GROUP: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Notification > User Group`,
    USER_LIST: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Notification > User List`,
    TAGS: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Tags`,
    PATH_LIST: `${MAIN_FRAMES.CONFIG_USER_ALERT_RULE_WINDOW}/Path List`,
  },
  CONFIG_USER_ALERT_NOTIFICATION_WINDOW: {
    NOTIFICATION: `${MAIN_FRAMES.CONFIG_USER_ALERT_NOTIFICATION_WINDOW}/Notification`,
    NOTIFICATION_ADD: `${MAIN_FRAMES.CONFIG_USER_ALERT_NOTIFICATION_WINDOW}/[Add] Notification`,
    NOTIFICATION_EDIT: `${MAIN_FRAMES.CONFIG_USER_ALERT_NOTIFICATION_WINDOW}/[Edit] Notification`,
  },

  // 시스템 알람
  CONFIG_SYSTEM_ALERT_INFRASTRUCTURE: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_INFRASTRUCTURE}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_INFRASTRUCTURE}/Host Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_INFRASTRUCTURE}/Host List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_INFRASTRUCTURE}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_NETWORK_DEVICE: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_NETWORK_DEVICE}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_NETWORK_DEVICE}/Network Device Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_NETWORK_DEVICE}/Device List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_NETWORK_DEVICE}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_KUBERNETES: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_KUBERNETES}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_KUBERNETES}/Cluster List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_KUBERNETES}/Node List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_KUBERNETES}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_APPLICATION: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_APPLICATION}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_APPLICATION}/WAS Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_APPLICATION}/WAS List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_APPLICATION}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_DATABASE: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_DATABASE}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_DATABASE}/Instance Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_DATABASE}/Instance List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_DATABASE}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE}/Message Queue Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE}/Message Queue List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_MESSAGE_QUEUE}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_WEB_SERVER: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_WEB_SERVER}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_WEB_SERVER}/Web Server Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_WEB_SERVER}/Web Server List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_WEB_SERVER}/Alert Setting`,
  },
  CONFIG_SYSTEM_ALERT_CLOUD: {
    GROUP_NOTIFICATION: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_CLOUD}/Group Notification`,
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_CLOUD}/Instance Group List`,
    TARGET_LIST: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_CLOUD}/Instance List`,
    ALERT_SETTING: `${MAIN_FRAMES.CONFIG_SYSTEM_ALERT_CLOUD}/Alert Setting`,
  },
  CONFIG_GROUP_NOTIFICATION_SETTING: {
    INFORMATION: `${MAIN_FRAMES.CONFIG_GROUP_NOTIFICATION_SETTING}/Information`,
    GROUP_NOTIFICATION_SAVE: `${MAIN_FRAMES.CONFIG_GROUP_NOTIFICATION_SETTING}/[Save] Group Notification`,
  },
  CONFIG_INTERFACE_SETTING_WINDOW: {
    INTERFACE_LIST: `${MAIN_FRAMES.CONFIG_INTERFACE_SETTING_WINDOW}/Interface List`,
    INTERFACE_SAVE: `${MAIN_FRAMES.CONFIG_INTERFACE_SETTING_WINDOW}/[Save] Interface`,
  },

  // 외부 알람
  CONFIG_EXTERNAL_ALERT: {
    GROUP_LIST: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT}/Alert Group List`,
    GROUP_DELETE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT}/[Delete] Alert Group`,
    RULE_LIST: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT}/Rule List`,
    RULE_DELETE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT}/[Delete] Rule`,
    ACTION_TOGGLE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT}/[Activate] Rule`,
  },

  CONFIG_EXTERNAL_ALERT_GROUP_WINDOW: {
    GROUP_SAVE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Save] Alert Group`,
    GROUP_UPDATE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Update] Alert Group`,
  },

  CONFIG_EXTERNAL_ALERT_WINDOW: {
    SAVE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Save] Alert Group`,
    UPDATE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Update] Alert Group`,
    DETAIL: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/Detail Information`,
    NOTIFICATION_DETAIL: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/Notification Detail Information`,
    NOTIFICATION_ADD: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Add] Notification`,
    NOTIFICATION_UPDATE: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/[Update] Notification`,
    EXTERNAL_ALERT_CHART_DATA: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/External Alert Chart Data`,
    EXTERNAL_ALERT_TABLE_DATA: `${MAIN_FRAMES.CONFIG_EXTERNAL_ALERT_WINDOW}/External Alert Table Data`,
  },

  // 알람 관리
  CONFIG_NOTIFICATION: {
    MESSENGER_TYPE_LIST: `${MAIN_FRAMES.CONFIG_NOTIFICATION}/Messenger Type LIST`,
    NOTIFICATION_LIST: `${MAIN_FRAMES.CONFIG_NOTIFICATION}/Notification List`,
    NOTIFICATION_DELETE: `${MAIN_FRAMES.CONFIG_NOTIFICATION}/[Delete] Notification`,
    NOTIFICATION_UPDATE: `${MAIN_FRAMES.CONFIG_NOTIFICATION}/[Update] Notification`,
  },
  CONFIG_NOTIFICATION_WINDOW: {
    NOTIFICATION: `${MAIN_FRAMES.CONFIG_NOTIFICATION_WINDOW}/Notification`,
    NOTIFICATION_ADD: `${MAIN_FRAMES.CONFIG_NOTIFICATION_WINDOW}/[Add] Notification`,
    NOTIFICATION_EDIT: `${MAIN_FRAMES.CONFIG_NOTIFICATION_WINDOW}/[Edit] Notification`,
  },
} as const;
